import {CryptoParameter,getSupportParameter} from "./keyEx";

export const getCyptoParamerter = (paramerterName:string):CryptoParameter|undefined => {
    const [keyex,crypto,sing] = paramerterName.split(",");
    const _p = getSupportParameter.public(keyex)
    const _s = getSupportParameter.sign(sing);
    const _d = getSupportParameter.datCrypto(crypto);
    if(!_p || !_s || !_d){
        return;
    }
    return {
        "dataCrypto":_d,
        "public":_p,
        "sign":_s,
    }
}

